module.exports = __webpack_public_path__ + "img/noshtribe_logo-black.86739702.jpg";